/**
 * These are the CMS view types categories for Testimonials for the following pages
 */
export enum TestimonialViewTypes {
  BEYOND_CX = 'beyond_cx',
  HOME = 'home',
  SUBSCRIPTION_DETAIL = 'subscription_detail',
}
